import { Grid } from '@mui/material';
import { AddItemButton } from '@tassat/button';
import { FilterModel, SortModel } from '@tassat/common-definitions';
import { FormModal } from '@tassat/modal';
import { noop } from 'lodash';
import React from 'react';

import SideList, { GridModelContext } from 'SharedComponents/sideList/';
import { IGridModelContext } from 'SharedComponents/sideList/gridModelContext';
import { GridToolbar } from 'SharedComponents/toolbar';

import { GridSettingsContext, ISideListLayoutProps } from '.';

export function SideListComponent(props: ISideListLayoutProps) {
    const {
        classes,
        rowData,
        columnDefs,
        gridOptions,
        formOptions
    } = props;

    const layoutSettings = React.useContext(GridSettingsContext);
    const [ sortModel, setSortModel ] = React.useState<SortModel>(null);
    const [ filterModel, setFilterModel ] = React.useState<FilterModel>(null);
    const [ search, setSearchValue ] = React.useState<string>('');
    const [ modalOpen, setModalOpen ] = React.useState<boolean>(false);

    const sortData = (selectedOption) => {
        let model;

        if (selectedOption.colId === 'clear') {
            model = null;
        } else if (sortModel && sortModel.colId === selectedOption.colId) {
            model = {
                colId: selectedOption.colId,
                sort: sortModel.sort === 'asc' ? 'desc' : 'asc'
            };
        } else {
            model = {
                colId: selectedOption.colId,
                sort: 'asc'
            };
        }

        setSortModel(model);
    };

    const filterData = (selectedOption) => {
        if (selectedOption.colId === 'clear') {
            selectedOption = null;
        }

        setFilterModel(selectedOption);
    };

    const renderModal = () => {
        if (formOptions?.Form) setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    const gridModel: IGridModelContext = {
        filterModel: filterModel,
        onFilter: filterData,
        sortModel: sortModel,
        onSort: sortData,
        onSearch: setSearchValue,
        searchValue: search,
        onFilterChange: noop
    };

    return (
        <GridModelContext.Provider value={gridModel}>
            <Grid
                className={classes.root}
                container
                direction='column'
                justifyContent='flex-start'
                spacing={0}
                wrap='nowrap'
            >
                <Grid
                    alignItems='center'
                    className={classes.toolbarContainer}
                    container
                    direction='row'
                    style={{ height: layoutSettings.options.headerHeight || 'auto' }}
                    wrap='nowrap'
                >
                    <Grid
                        item
                        md={5}
                        xs={6}
                    >
                        {/* Undefined showAddButton should still show button */}
                        {formOptions?.Form && (formOptions?.showAddButton !== false) &&
                            <Grid
                                className={classes.buttonToolbar}
                                item
                            >
                                <AddItemButton
                                    onClick={renderModal}
                                    text={formOptions?.formTitle}
                                />
                            </Grid>}
                    </Grid>
                    <Grid
                        container
                        item
                        justifyContent='flex-end'
                        md={7}
                        xs={6}
                    >
                        <GridToolbar
                            gridOptions={gridOptions}
                            id='sideList'
                        />
                    </Grid>
                </Grid>
                <Grid
                    className={classes.gridContainer}
                    item
                >
                    <SideList
                        columnDefs={columnDefs}
                        gridOptions={gridOptions}
                        rowData={rowData}
                    />
                </Grid>
            </Grid>
            {formOptions?.Form &&
                <FormModal
                    Form={formOptions?.Form}
                    formProps={formOptions?.formProps || {}}
                    modalWidth={formOptions?.formModalWidth}
                // TODO: Make open and close of modal a reducer
                    onClose={() => {
                    if (formOptions?.formProps && formOptions?.formProps.onClose){
                        formOptions?.formProps.onClose();
                    }
                    closeModal();
                }}
                    open={modalOpen || formOptions?.formProps?.modalOpen || false}
                    title={formOptions?.formTitle}
                />}
        </GridModelContext.Provider>
    );
}